import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const { VITE_AUTH0_DOMAIN, VITE_AUTH0_CLIENT_ID, VITE_AUTH0_AUDIENCE } =
  import.meta.env;

export const HasuraCustomClaimsNamespace = 'https://hasura.io/jwt/claims';

export interface HasuraCustomClaims {
  'x-hasura-allowed-roles': string[];
  'x-hasura-default-role': string;
  'x-hasura-user-company': string;
  'x-hasura-user-email': string;
  'x-hasura-user-id': string;
}

interface AuthProviderProps {
  children: React.ReactNode;
}

function AuthProvider({ children, ...props }: AuthProviderProps) {
  const navigate = useNavigate();

  const handleRedirectCallback = (appState?: AppState) => {
    navigate((appState && appState.returnTo) || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={VITE_AUTH0_DOMAIN}
      clientId={VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: VITE_AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={handleRedirectCallback}
      {...props}
    >
      {children}
    </Auth0Provider>
  );
}

export { AuthProvider };
